export default "__VITE_ASSET__9ef423b4__"